import React, { useState, useEffect, useRef, useCallback } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { RiMenuLine } from "react-icons/ri";
import DropdownUser from "./DropdownUser";
import logo from "../assests/BEFLogo.png";
import { AiOutlineCloseSquare } from "react-icons/ai";
import { getSingleClasses, useUser } from "../redux/services/authSlice";
import { useDispatch, useSelector } from "react-redux";

const Navbar = () => {
  const {user} = useUser()
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const [isDropdownMenuOpen, setIsDropdownMenuOpen] = useState(false);
  const getsingleClassesData = useSelector(
    (state) => state?.auth?.singleClassesData
  );
  const menuRef = useRef();
  const classesId = localStorage.getItem("classesId");
  const toggleMenu = () => {
    setIsDropdownMenuOpen((prevState) => !prevState);
  };
  const getSingleRecord = useCallback(async () => {
    try {
      await dispatch(getSingleClasses(classesId));
    } catch (error) {}
  }, [dispatch, classesId]);

  useEffect(() => {
    if (classesId) {
      getSingleRecord();
    }
  }, [classesId, getSingleRecord]);
  useEffect(() => {
    const checkIfClickedOutside = (e) => {
      if (
        isDropdownMenuOpen &&
        menuRef.current &&
        !menuRef.current.contains(e.target)
      ) {
        setIsDropdownMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", checkIfClickedOutside);
    return () => {
      document.removeEventListener("mousedown", checkIfClickedOutside);
    };
  }, [isDropdownMenuOpen]);

  const { pathname } = location;

  return (
    <>
      <header className="sticky top-0 z-10 h-20 flex w-full bg-white shadow-md">
        <div className="flex flex-grow items-center gap-x-10 px-4 py-4 md:px-6 2xl:px-11">
          <div className="flex items-center space-x-3 cursor-pointer" onClick={()=>navigate("/")}>
            <div className="flex flex-col items-start justify-center">
              <img src={logo} alt="Achiwon" className="h-8 w-auto object-contain" />
              <span className="text-[9px] text-[#F48224] font-semibold tracking-wider leading-none mt-1">
                UPSC & GPSC CSE
              </span>
            </div>
            <p className="text-md lg:text-lg font-semibold text-gray-800">
              X {user?.name || getsingleClassesData?.name}
            </p>
          </div>

          <nav className="hidden lg:block">
            <ul className="flex gap-4">
              <li>
                <Link
                  to="/"
                  className={`py-2 px-4 rounded-md font-medium ${
                    pathname === "/"
                      ? "text-white bg-[#124699]"
                      : "text-black hover:bg-[#e8effa]"
                  }`}
                >
                  Dashboard
                </Link>
              </li>
              <li>
                <Link
                  to="/subjects"
                    className={`py-2 px-4 rounded-md font-medium ${
                      pathname === "/subjects" ||
                      pathname === "/subjectDetails" ||
                      pathname === "/addQuestion" ||
                      pathname === "/editQuestion"
                      ? "text-white bg-[#124699]"
                      : "text-black hover:bg-[#e8effa]"
                  }`}
                >
                  Add Question
                </Link>
              </li>
              <li>
                <Link
                  to="/student"
                  className={`py-2 px-4 rounded-md font-medium ${
                    pathname === "/student"
                      ? "text-white bg-[#124699]"
                      : "text-black hover:bg-[#e8effa]"
                  }`}
                >
                  Students
                </Link>
              </li>
            </ul>
          </nav>
        </div>

        <div className="flex items-center gap-x-3 px-4 py-4">
          <DropdownUser getsingleClassesData={getsingleClassesData} />
          <button
            className="text-md lg:hidden text-gray-600 p-2 border border-[#124699] hover:bg-blue-50 rounded-full"
            onClick={toggleMenu}
            title="Menu"
          >
            <RiMenuLine className="h-6 w-6" />
          </button>
        </div>
      </header>

      {isDropdownMenuOpen && (
        <div
          className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 z-40"
          onClick={toggleMenu}
        ></div>
      )}

      <div
        ref={menuRef}
        className={`${
          isDropdownMenuOpen
            ? "translate-x-0 opacity-100"
            : "translate-x-full opacity-0"
        } fixed top-0 right-0 w-80 h-full bg-white px-4 shadow-lg transition-all duration-300 ease-in-out`}
        style={{ zIndex: "1000" }}
      >
        <div className="flex justify-end pt-7">
          <button
            className="text-xl text-gray-600"
            onClick={toggleMenu}
            title="Close Menu"
          >
            <AiOutlineCloseSquare className="h-[30px] w-[30px]" />
          </button>
        </div>

        <nav className="h-full pt-5">
          <ul className="flex flex-col gap-2">
            <li className="w-full" onClick={() => setIsDropdownMenuOpen(false)}>
              <Link
                to="/"
                className={`w-full py-2 px-4 rounded-md font-medium block ${
                  pathname === "/"
                    ? "text-white bg-[#124699]"
                    : "text-black hover:bg-[#e8effa]"
                }`}
              
              >
                Dashboard
              </Link>
            </li>
            <li className="w-full" onClick={() => setIsDropdownMenuOpen(false)}>
              <Link
                to="/subjects"
                className={`py-2 px-4 w-full rounded-md font-medium block ${
                  pathname === "/subjects"
                    ? "text-white bg-[#124699]"
                    : "text-black hover:bg-[#e8effa]"
                }`}
              >
                Add Question
              </Link>
            </li>
            <li className="w-full" onClick={() => setIsDropdownMenuOpen(false)}>
              <Link
                to="/student"
                className={`py-2 px-4 w-full rounded-md font-medium block ${
                  pathname === "/student"
                    ? "text-white bg-[#124699] "
                    : "text-black hover:bg-[#e8effa]"
                }`}
              >
                Students
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </>
  );
};

export default Navbar;
